import { render, staticRenderFns } from "./LevelUnitReportIndividual.vue?vue&type=template&id=289bcf8a&scoped=true&"
import script from "./LevelUnitReportIndividual.vue?vue&type=script&lang=ts&"
export * from "./LevelUnitReportIndividual.vue?vue&type=script&lang=ts&"
import style0 from "./LevelUnitReportIndividual.vue?vue&type=style&index=0&id=289bcf8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289bcf8a",
  null
  
)

export default component.exports